const ProfileConfig = {
  endpoints: {
    settingsedit: "/usersettings/edit",
    settingsget: "/usersettings/show",
    profilePicture: "/profile/profilePicture/",
    systemProfile: "/profile/systemprofile",
    editSystemProfile: "/profile/systemprofile/edit",
  },
  datafield: "profile",
};

export { ProfileConfig };
